<template lang="pug">
div
	h1 {{contentpage.name}}
	ws-content(:value="contentpage.content")
</template>

<script>
import gql from 'graphql-tag';
import Content from '@dengl/common/components/content.vue';
import NskivInfoItem from '@/components/nskiv-info-item';
import MetaFragment from '@/components/graphql/metaFragment.graphql';

const getContentpageWithSlug = gql`
	query getContentpageWithSlug($path: String!) {
		contentpage(path: $path) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			parent {
				id
				name
				slug
			}
			children {
				name
				slug
				isHiddenInMenu
				menu_title
				...MetaFragment
			}
			...MetaFragment
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	name: 'VerzekeringSlug',
	components: { NskivInfoItem },
	async middleware({ app, route, error, redirect }) {
		await app.$graphClient
			.query({
				query: gql`
					query getContentpageWithPathRedirect($path: String!) {
						contentpage(path: $path) {
							id
							...MetaFragment
						}
					}
					${MetaFragment}
				`,
				variables: {
					path: route.path,
					context: {
						isMiddleware: true
					}
				}
			})
			.then(({ data }) => {
				// TODO: Dit zou een losse resolver kunnen worden zodat we dit voor meer types kunnen gebruiken.
				// https://trello.com/c/NanPoj3R/4364-statuscodeforpath-resolver

				if (!data.contentpage) {
					return error({ statusCode: 404, message: 'Page not found' });
				}

				if (data.contentpage.meta.redirect) {
					return redirect(302, data.contentpage.meta.redirect);
				}
			})
			.catch(error => {
				if (error.message.includes('no content page found with slug')) {
					return app.httpError(404, null, 'verzekering-slug-03', error);
				}

				return app.httpError(500, null, 'verzekering-slug-04', error);
			});
	},
	scrollToTop: true,
	nuxtI18n: {
		paths: {
			'nl-NL': '/verzekering/:slug',
			'nl-BE': '/verzekering/:slug'
		}
	},
	asyncData({ params, app, route }) {
		app.ads({ sidebar: { visible: true } });

		return app.$graphClient
			.query({
				query: getContentpageWithSlug,
				variables: {
					path: route.path
				}
			})
			.then(({ data }) => {
				if (!data.contentpage)
					return app.httpError(
						404,
						null,
						'verzekering-slug-00',
						'Page not found'
					);

				let breadcrumbs = {};

				breadcrumbs = {
					Verzekering: {
						name: 'verzekering'
					}
				};

				breadcrumbs[data.contentpage.name] = {
					name: 'verzekering-slug',
					params: { slug: params.slug }
				};

				app.meta(data.contentpage.meta);
				app.breadcrumbs(breadcrumbs);

				return data;
			})
			.catch(error => {
				if (
					['no content page found', 'can not be found'].some(v =>
						error.message.includes(v)
					)
				) {
					return app.httpError(404, null, 'verzekering-slug-00', error);
				}
				return app.httpError(500, null, 'verzekering-slug-01', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
